import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import InvitationPage from "./invitation/index";
import EULAPage from "./public/eula";
import DataDeletionPage from "./public/data-deletion";
import UnauthorisedPage from "./public/unauthorised";

const handleRouting = (isAuthenticated, children, location) => {
  console.log("=== handleRouting === ");
  console.log("isAuthenticated", isAuthenticated);
  console.log("location", location);
  if (isAuthenticated) {
    return children;
  }
  localStorage.setItem("nextUrl", location.pathname + location.search);
  return (
    <Redirect
      to={{
        pathname: AUTH_PREFIX_PATH,
        state: { from: location },
      }}
    />
  );
};

function RouteInterceptor({ children, ...rest }) {
  const { isAuthenticated, isLoading } = useKindeAuth();

  if (isLoading) {
    return <div />;
  }

  if (!isLoading) {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          handleRouting(isAuthenticated, children, location)
        }
      />
    );
  }
}

export const Views = (props) => {
  const { location, direction } = props;
  console.log("Views location", { location });
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to={APP_PREFIX_PATH} />
      </Route>
      <Route path={AUTH_PREFIX_PATH}>
        <AuthLayout direction={direction} />
      </Route>
      <Route path="/invitation/:invitationToken">
        <InvitationPage />
      </Route>
      <Route path="/eula">
        <EULAPage />
      </Route>
      <Route path="/data-deletion">
        <DataDeletionPage />
      </Route>
      <Route path="/unauthorised">
        <UnauthorisedPage />
      </Route>
      <RouteInterceptor path={APP_PREFIX_PATH}>
        <AppLayout direction={direction} location={location} />
      </RouteInterceptor>
    </Switch>
  );
};

const mapStateToProps = ({ theme }) => {
  const { locale, direction } = theme;
  return { locale, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
